import { render, staticRenderFns } from "./EquipamentsActive.vue?vue&type=template&id=0fdb7706&scoped=true&"
import script from "./EquipamentsActive.vue?vue&type=script&lang=js&"
export * from "./EquipamentsActive.vue?vue&type=script&lang=js&"
import style0 from "./EquipamentsActive.vue?vue&type=style&index=0&id=0fdb7706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb7706",
  null
  
)

export default component.exports